import { render, staticRenderFns } from "./muserGroup.vue?vue&type=template&id=4be18ad0&scoped=true&"
import script from "./muserGroup.vue?vue&type=script&lang=js&"
export * from "./muserGroup.vue?vue&type=script&lang=js&"
import style0 from "./muserGroup.vue?vue&type=style&index=0&id=4be18ad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be18ad0",
  null
  
)

export default component.exports